import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setSelectableDepotsAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (event.type !== "DEPOTS_LOADED") return {};

  return {
    selectableDepots: event.depots,
  };
};
